import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { SlugAvailabilityDtoApiModel, TenantApiService } from '../../api';

export const SLUG_MAX_LENGTH = 63;

export const STOREFRONT_BASE_DOMAIN: string = environment.storefrontBaseDomain;

@Injectable({ providedIn: 'root' })
export class TenantSlugService {
  private readonly tenantApi = inject(TenantApiService);

  public slugify(input: string): string {
    return this.normalizeSlug(input)
      .replace(/^-|-$/g, '')
      .slice(0, SLUG_MAX_LENGTH)
      .replace(/-$/, '');
  }

  public slugifyWhileTyping(input: string): string {
    return this.normalizeSlug(input).replace(/^-/, '').slice(0, SLUG_MAX_LENGTH);
  }

  private normalizeSlug(input: string): string {
    return input
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-');
  }

  public checkAvailability(
    slug: string,
  ): Observable<SlugAvailabilityDtoApiModel> {
    return this.tenantApi.tenantControllerCheckSlugAvailability(slug);
  }
}
